import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import createMutationsSharer from "./Lib/vuex-shared-mutations/vuexSharedMutations.js";
import LocalStorageStrategy from "./Lib/vuex-shared-mutations/strategies/localStorage.js";
import axios from "axios";
// var categories = require("./data/categories.json");
import * as cookies from "js-cookie";
Vue.use(Vuex);

const vuexPersistSession = new VuexPersistence<any>({
    key: 'basket',
    storage: localStorage,
    reducer: state => ({basket: state.basket})
});
const vuexPersistLocal = new VuexPersistence<any>({
    key: 'checkoutInfo',
    storage: localStorage,
    reducer: state => ({checkoutInfo: state.checkoutInfo})
});
const vuexPersistLocalUdlejning = new VuexPersistence<any>({
    key: 'udlejningInfo',
    storage: localStorage,
    reducer: state => ({udlejningInfo: state.udlejningInfo})
});

function setSessionCookie(){
    // console.log("setting session cookie");
    cookies.set("session", new Date().toDateString(), { path: '/' });
}
if(!cookies.get("session", { path: '/' }) || cookies.get("session", { path: '/' }) != new Date().toDateString() )
{
    // if(window["console"] && window["console"]["log"])
    //     console.log("clearing session");
    // clear local storage
    window.localStorage.removeItem("basket");
    // window.localStorage.removeItem("checkoutInfo");
    // window.localStorage.removeItem("udlejningInfo");
}


export default new Vuex.Store<any>({
    plugins: [vuexPersistSession.plugin, vuexPersistLocal.plugin, vuexPersistLocalUdlejning.plugin, createMutationsSharer({ 
        predicate: ["UpdateBasket", "UpdateCheckoutInfo", "UpdateUdlejningInfo"],
        strategy : new LocalStorageStrategy() 
    })],
    // plugins: [vuexPersistSession.plugin, vuexPersistLocal.plugin, vuexPersistLocalUdlejning.plugin],
    state: {
        basket : [
        ],
        checkoutInfo : {
            firmaNavn : "",
            cvr : "",
            navn : "",
            adresse : "",
            postnr : "",
            by : "",
            email : "",
            telefon : "",
            mobil : "",
            shipToOtherAdress : "",
            shipNavn : "",
            shipFirmaNavn : "",
            shipAdresse : "",
            shipPostnr : "",
            shipBy : "",
            paymentType : "credit",
            delivery : "ship",
            customerType: "privat",
            comment : "",
            maaStilles : false,
            maaStillesInfo : "",
            deliverDateSpecified : false,
            deliverDate : null,
            eanNummer : "",
            eanRekv : "",
            eanBrugerId : "",
            pickupStore : "",
            newsletter : false,
            rabatkode : "",
        },
        udlejningInfo : {
            comment : "",
            name : "",
            contact : "email",
            email : "",
            phone : ""
        }
    },
    getters:{
        GetBasket : state=> state.basket,
        GetCheckoutInfo : state => state.checkoutInfo,
        GetUdlejningInfo : state => state.udlejningInfo
    },
    mutations: {
        UpdateBasket(state, basket) {
            setSessionCookie();
            state.basket = basket;
        },
        UpdateCheckoutInfo(state, checkoutInfo){
            setSessionCookie();
            state.checkoutInfo = checkoutInfo;
        },
        UpdateUdlejningInfo(state, udlejningInfo){
            setSessionCookie();
            state.udlejningInfo = udlejningInfo;
        }
    },
    actions: {
        UpdateBasket({ commit, state }, basket){
            commit('UpdateBasket', basket);
        },
        UpdateCheckoutInfo({ commit, state }, checkoutInfo){
            commit('UpdateCheckoutInfo', checkoutInfo);
        },
        UpdateUdlejningInfo({ commit, state}, udlejningInfo){
            commit('UpdateUdlejningInfo', udlejningInfo);
        }
    },
});
